import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7006Model } from '../kymw7006.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
interface GetOrderCodeByDelivCatalogIdResponse {
  OrderCode: string;
}

/**
 * 受注コード取得サービス
 * @export GetOrderCodeByDelivCatalogIdService
 * @class GetOrderCodeByDelivCatalogIdService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetOrderCodeByDelivCatalogIdService extends PlessJsonResponderSub<GetOrderCodeByDelivCatalogIdResponse> {
  model: KYMW7006Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetOrderCodeByDelivCatalogIdService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        DelivCatalogId: this.model.catalogId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetOrderCodeByDelivCatalogIdService
   */
  execute(model: KYMW7006Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('getOrderCodeByDelivCatalogId', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetOrderCodeByDelivCatalogIdService
   */
  success(data: GetOrderCodeByDelivCatalogIdResponse) {
    this.model.orderCode = data.OrderCode;
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
